module.exports = __webpack_public_path__ + "static/media/b-sci-major-7_LR.34fb22f1.jpg";